<template>
	<div
		:class="['panel',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[ isBrand? 'sk' : '', ]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<div class="row">
					<div class="col-12">
						<h2>{{ block.block_title }}</h2>
					</div>
				</div>
			</div>

			<div v-if="block.display_as_slider" class="partners-slider">
				<div v-swiper:partnersSwiper="options" class="partners-swiper">
					<div class="swiper-wrapper">
						<div
							v-for="(item, index) in block.items"
							:key="index"
							class="swiper-slide"
							:class="[
								block.columns === '6'
									? 'col-6 col-sm-4 col-md-3 col-lg-2'
									: 'col-12 col-sm-6 col-lg-'+ 12/block.columns,
							]"
						>
							<div class="partner">
								<div class="logo embed-responsive embed-responsive-1by1">
									<a v-if="item.url" :href="item.url" rel="nofollow" target="_blank">
										<b-img-lazy :src="item.logo.src" class="embed-responsive-item" />
									</a>
									<b-img-lazy v-else :src="item.logo.src" class="embed-responsive-item" />
								</div>
								<div
									v-if="((block.columns !=6) && (item.description))"
									class="description"
									v-html="item.description"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="swiper-navigation">
					<div id="swiper-timeline-prev" class="btn btn-outline-primary icon-arrow_prev" />
					<div id="swiper-timeline-next" class="btn btn-outline-primary icon-arrow_next" />
				</div>
			</div>

			<div v-else class="partners-block">
				<ul class="partners-list row">
					<li
						v-for="(item, index) in block.items"
						:key="index"
						:class="[
							block.columns === '6'
								? 'col-6 col-sm-4 col-md-3 col-lg-2'
								: 'col-12 col-sm-6 col-lg-'+ ( block.columns ? 12/block.columns : 3 ),
						]"
					>
						<div class="partner">
							<div class="logo embed-responsive embed-responsive-1by1">
								<a v-if="item.url" :href="item.url" rel="nofollow" target="_blank">
									<b-img-lazy :src="item.logo.src" class="embed-responsive-item" />
								</a>
								<b-img-lazy v-else :src="item.logo.src" class="embed-responsive-item" />
							</div>
							<div
								v-if="((block.columns !=6) && (item.description))"
								class="description"
								v-html="item.description"
							/>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import panel from '~/mixins/panel';

export default {
	name: 'PanelPartnersDynamic',
	components: {
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	mixins: [panel],

	data() {
		return {
			modalContent: null,

			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				// autoplay: true,
				// loop: true,

				// cssMode: false,
				// freeMode: true,

				navigation: {
					nextEl: '.icon-arrow_next',
					prevEl: '.icon-arrow_prev',
					// nextEl: "#swiper-timeline-next",
					// prevEl: "#swiper-timeline-prev",
					disabledClass: 'disabled',
				},
			},
		};
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-partners-list";
</style>
